import { createConfig } from "@yourfutureacademy/scripts";

export default createConfig (
    {
        ID:"5974604",
        OTAP:{
            Value:0,
            URLOnt:"http://192.168.1",
            URLTes:"https://distracted-feynman-006a31.netlify.app",
            URLAcc:"https://goedkeuring-klant-trompetty.netlify.app",
            URLPro:"https://trompetty-offerte-tool.netlify.app/",
            URLLocHost:"http://localhost:80"
        },
        Zapier:{
            Ont:"b8hh09i",
            Tes:"b8h0nnr",
            Acc:"b8rqr7c",
            Pro:"bzr9r6y"
        }
    }
);

